import { render } from "./UpdateRoute.vue?vue&type=template&id=280d9d38&scoped=true"
import script from "./UpdateRoute.vue?vue&type=script&lang=js"
export * from "./UpdateRoute.vue?vue&type=script&lang=js"

import "./UpdateRoute.vue?vue&type=style&index=0&id=280d9d38&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-280d9d38"]])

export default __exports__